/**
 * Persist cashout-per-market locks across reloads. Scoped to login-session so
 * a new session does not inherit another user's (or stale) locks.
 */
const STORAGE_KEY = 'bet-cashout-locked-markets-v1'

type CashoutLockStore = {
  sessionId: string
  locks: Record<string, true>
}

function getSessionId(): string {
  if (typeof window === 'undefined') return ''
  try {
    return localStorage.getItem('login-session') || ''
  } catch {
    return ''
  }
}

export function loadPersistedCashoutLockKeys(): Record<string, true> {
  if (typeof window === 'undefined') return {}
  try {
    const sessionId = getSessionId()
    if (!sessionId) return {}
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as CashoutLockStore
    if (!parsed || parsed.sessionId !== sessionId) return {}
    return parsed.locks && typeof parsed.locks === 'object' ? { ...parsed.locks } : {}
  } catch {
    return {}
  }
}

export function persistCashoutLockKeys(locks: Record<string, true>): void {
  if (typeof window === 'undefined') return
  try {
    const sessionId = getSessionId()
    if (!sessionId) {
      localStorage.removeItem(STORAGE_KEY)
      return
    }
    if (Object.keys(locks).length === 0) {
      localStorage.removeItem(STORAGE_KEY)
      return
    }
    const payload: CashoutLockStore = { sessionId, locks: { ...locks } }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  } catch {
    // QuotaExceededError, private mode, etc.
  }
}

/** Call on logout so stale locks are not associated with the next session client-side. */
export function clearPersistedCashoutLockKeys(): void {
  if (typeof window === 'undefined') return
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
